export const TRACK_API_BASE_URL = process.env.REACT_APP_TRACK_API_BASE_URL;
export const TRACK_BASE_URL = window.location.origin;

export const DASHBOARD_URL = process.env.REACT_APP_DATAPILOT_URL;

const extractHostname = (url) => {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return '';
  }
};
export const IS_DASHBOARD_MODE = DASHBOARD_URL
  ? extractHostname(TRACK_BASE_URL) === extractHostname(DASHBOARD_URL)
  : false;

export const LOGIN_URL = `${TRACK_API_BASE_URL}/auth/url/?redirect_uri=${TRACK_BASE_URL}/login_done/`;
// Switch-user redirects to the login_done handler route so <LoginDone> can
// exchange the OAuth `code`; the real return path is restored from
// sessionStorage['redirect'] there.
export const SWITCH_USER_URL = `${TRACK_API_BASE_URL}/auth/switch-user/?redirect_uri=${TRACK_BASE_URL}/`;
export const LOGIN_DONE_URL = `${TRACK_API_BASE_URL}/auth/`;
export const ME_URL = `${TRACK_API_BASE_URL}/auth/me/`;

export const HIDDEN_TABS = process.env.REACT_APP_HIDDEN_TABS || [];

export const LOCALE = process.env.REACT_APP_LOCALE || 'en-US';

// List of fix statuses and translation from server.
export const FIX_STATUS_DISPLAY = {
  active: 'Active',
  fixed: 'Fixed',
  fix_later: "Can't Fix",
  failed_after_fix: 'Failed after fix',
};

export const REVIEW_STATUS_DISPLAY = {
  review_promote: 'Promote',
  review_retain: 'Retain',
  review_exit: 'Exit',
  review_transfer: 'Transfer',
  NA: 'N/A (Data problem)',
};

export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const GRADES = [
  {value: -1, label: 'Pre-K'},
  {value: 0, label: 'Kindergarten'},
  {value: 1, label: '1st Grade'},
  {value: 2, label: '2nd Grade'},
  {value: 3, label: '3rd Grade'},
  {value: 4, label: '4th Grade'},
  {value: 5, label: '5th Grade'},
  {value: 6, label: '6th Grade'},
  {value: 7, label: '7th Grade'},
  {value: 8, label: '8th Grade'},
  {value: 9, label: '9th Grade'},
  {value: 10, label: '10th Grade'},
  {value: 11, label: '11th Grade'},
  {value: 12, label: '12th Grade'},
  {value: 100, label: 'Cross Grade'},
];

export const CROSS_GRADE = 100;

export const GRADESPANS = ['PK', 'ES', 'MS', 'HS'];

// export const aggregationOptions = [
//   'COUNT',
//   'DISTINCT',
//   'SUM',
//   'AVG',
//   'MIN',
//   'MAX',
// ];

// export const filterOptions = ['DATE', 'INTEGER', 'FREE_TEXT', 'OPTIONS'];

// export const stringOperators = [
//   'EQUALS',
//   'NOT_EQUALS',
//   'CONTAINS',
//   'NOT_CONTAINS',
//   'STARTS_WITH',
//   'ENDS_WITH',
//   'IS_NULL',
//   'IS_NOT_NULL',
// ];

// export const optionsOperators = ['IN', 'NOT_IN', 'IS_NULL', 'IS_NOT_NULL'];

export const FILTER_OPERATORS = [
  'EQUALS',
  'NOT_EQUALS',
  'GREATER_THAN',
  'GREATER_THAN_OR_EQUAL',
  'LESS_THAN',
  'LESS_THAN_OR_EQUAL',
  'BETWEEN',
];

export const TYPES_FOR_FILTER = {
  DATE: ['DATE'],
  FREE_TEXT: ['STRING', 'INTEGER', 'DATE'],
  INTEGER: ['INTEGER'],
  OPTIONS: ['STRING', 'INTEGER', 'DATE', 'BOOLEAN'],
};

export const METRICS_FOR_AGGREGATION_TYPE = {
  COUNT: ['INTEGER', 'DATE', 'BOOLEAN', 'STRING'],
  DISTINCT: ['INTEGER', 'DATE', 'BOOLEAN', 'STRING'],
  SUM: ['INTEGER'],
  AVG: ['INTEGER'],
  MIN: ['INTEGER', 'DATE'],
  MAX: ['INTEGER', 'DATE'],
};

export const COLUMN_TYPES = [
  {value: 'autocomplete', label: 'Autocomplete'},
  {value: 'boolean', label: 'Boolean'},
  {value: 'date', label: 'Date'},
  {value: 'dropdown', label: 'Options'},
  {value: 'dropdown_numeric', label: 'Options (numeric)'},
  {value: 'numeric', label: 'Numeric'},
  {value: 'text', label: 'Text'},
  // {value: 'regex', label: 'Regex'},
];

export const STATUSES = {
  edited: {
    // the row has been edited
    label: 'Edited',
    color: 'var(--secondary-color)',
    icon: 'edit_note',
  },
  added: {
    // the row is new
    label: 'New Rows',
    color: 'var(--success-color)',
    icon: 'add_circle',
  },
  removed: {
    // the row is empty
    label: 'Removed',
    color: 'var(--warning-color)',
    icon: 'remove_circle',
  },
  missing: {
    // the row has empty cells (list of empty cells)
    label: 'Missing Values',
    color: 'var(--gray-color)',
    icon: 'help',
  },
  duplicate: {
    // the primary key is not unique OR the row has a non-unique value in a unique column (list of duplicate columns or sets of columns)
    label: 'Duplicates',
    color: 'var(--link-color)',
    icon: 'content_copy',
  },
  invalid: {
    // the row has invalid cells (list of invalid cells)
    label: 'Invalid Values',
    color: 'var(--error-color)',
    icon: 'error',
  },
};

export const PERMISSIONS = [
  'access_to_audits',
  'access_to_data_portal',
  'access_to_data_portal_editor',
  'access_to_data_reports',
  'access_to_data_reports_editor',
  'access_to_esoy',
  'access_to_hs_schedule',
  'access_to_search',
  'access_to_source_manager',
  'access_to_source_manager_editor',
  'access_to_staff_account_status',
  'access_to_ucpids',
  'can_view_all_schools',
  'can_view_esoy_overview',
];

// Messages browsers give a fetch() that failed at the transport level (offline,
// a navigation aborting the request, CORS, DNS) — Chrome, Firefox, Safari.
// Exact match so e.g. "Failed to fetch dynamically imported module" isn't caught.
export const FETCH_FAILURE_MESSAGE_RE =
  /^(TypeError: )?(Failed to fetch|NetworkError when attempting to fetch resource\.|Load failed)$/;
